import React from 'react';
import { IProps as ICookieConsentProps } from './CookieConsentBlock.interface';
import { CookieConsentBlock } from './CookieConsentBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

// Define the input props structure, which might come from a CMS or other data source
export interface ICookieConsentInputProps {
    message: string;
    cookieConsentId: string;
    expireInDays: number;
    // Allow passthrough of other props, especially for BlockWrapper
    [key: string]: any;
}

/**
 * Maps input props (e.g., from a CMS) to the props expected by the GlobalNotificationBlock component.
 * @param input - The input props.
 * @returns The mapped props for the GlobalNotificationBlock component.
 */
const mapInputToProps = (
    input: ICookieConsentInputProps,
): ICookieConsentProps => {
    return {
        ...input,
    };
};

const CookieConsentBlockTranslation: React.FC<ICookieConsentInputProps> = (
    inputProps,
) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={CookieConsentBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default CookieConsentBlockTranslation;
